
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/me/exam-history",
      function () {
        return require("private-next-pages/me/exam-history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/me/exam-history"])
      });
    }
  